import React from 'react';

import { Box, Container, Flex, Image, Text, VStack } from '@chakra-ui/react';

import { AppHeaderOld } from '@app/components/organisms/app-header-old';
import { FooterSmall } from '@app/components/organisms/footer-small';

interface OwnProps {
    code: number;
    translationData: { reason: string };
    imgSrc: string;
    children: React.ReactNode;
}

const containerProps = {
    maxWidth: 'containerWidth',
    px: {
        base: 'gutterWidth',
        md: 'gutterWidthDesktop',
    },
};

export const Error = ({ code, imgSrc, translationData, children }: OwnProps) => {
    return (
        <VStack h={'100vh'}>
            <AppHeaderOld isSimplified={true} />
            <Container {...containerProps}>
                <Flex flexDirection="column" alignItems="center" ml={2} mr={2}>
                    <Box position="relative" pb={{ base: 150, md: 0 }} mb={{ base: 6, md: 0 }}>
                        <Image
                            src={imgSrc}
                            width={{ base: '307px', md: '400px' }}
                            alt="error"
                            position="absolute"
                            left="50%"
                            transform="translate(-50%,0)"
                            bottom={{
                                base: '0%',
                                md: '20%',
                            }}
                        />
                        <Text
                            fontSize={{ base: 172, md: 500 }}
                            fontWeight={700}
                            color="red.50"
                            lineHeight={1}
                            textAlign="center"
                        >
                            {code}
                        </Text>
                    </Box>
                    <Text
                        fontSize={{ base: '3xl', md: '5xl' }}
                        fontWeight={700}
                        mb={35}
                        textAlign="center"
                        lineHeight={1}
                    >
                        {translationData.reason}
                    </Text>
                    {children}
                </Flex>
            </Container>
            <FooterSmall width="100%" mt={'auto'} />
        </VStack>
    );
};
